import * as React from 'react';
import {Link} from '@tanstack/react-router';
import { RiErrorWarningLine } from '@remixicon/react';
import {Button} from '@/components/atoms/button.tsx';

export default function NotFound() {
  return(<div className="main-content">
          <div><RiErrorWarningLine /></div>
          <h1 className="page-title">Page not found</h1>
          <div className="space-y-32">
            <Link to="/">
              <Button>Return to homepage</Button>
            </Link>
          </div>
        </div>
  );
}
